import React from 'react';
import PropTypes from 'prop-types';
import {LabelledInfo} from '../molecules';
import {formatBoolean, formatInt} from '../utils/formats';
import Link from '@material-ui/core/Link';

// Field components
const Version = ({system}) => <LabelledInfo title="Software Version" subtitle={system.softwareVersion || '-'} style={{marginTop: '24px'}}/>;
const Aep = ({system}) => <LabelledInfo title="AEP Enable" subtitle={formatBoolean(system.aepEnable)} style={{marginTop: '24px'}}/>;
const Eep = ({system}) => <LabelledInfo title="EEP Enable" subtitle={formatBoolean(system.eepEnable)} style={{marginTop: '24px'}}/>;
const Gxl = ({system}) => <LabelledInfo title="GXL" subtitle={formatBoolean(system.gxl)} style={{marginTop: '24px'}}/>;
const Gxxl = ({system}) => <LabelledInfo title="GXXL" subtitle={formatBoolean(system.gxxl)} style={{marginTop: '24px'}}/>;
const HexapodOrientation = ({system}) => <LabelledInfo title="Hexapod Orientation" subtitle={formatInt(system.hexapodOrientation)} style={{marginTop: '24px'}}/>;
const Hoist = ({system}) => <LabelledInfo title="Hoist" subtitle={formatBoolean(system.hoist)} style={{marginTop: '24px'}}/>;
const OneOperator = ({system}) => <LabelledInfo title="One Operator" subtitle={formatBoolean(system.oneOperator)} style={{marginTop: '24px'}}/>;
const PinocchioTip = ({system}) => <LabelledInfo title="Pinocchio Tip" subtitle={formatBoolean(system.pinocchioTip)} style={{marginTop: '24px'}}/>;
const PinPushers = ({system}) => <LabelledInfo title="Pin Pushers" subtitle={formatBoolean(system.pinPushers)} style={{marginTop: '24px'}}/>;
const SlewingEncoder = ({system}) => <LabelledInfo title="Slewing Encoder" subtitle={formatBoolean(system.slewingEncoder)} style={{marginTop: '24px'}}/>;
const TipHeaveCompensation = ({system}) => <LabelledInfo title="Tip Heave Compensation" subtitle={formatBoolean(system.tipHeaveCompensation)} style={{marginTop: '24px'}}/>;
const BoxPC = ({system}) => <LabelledInfo title="Box PC" subtitle={formatBoolean(system.boxPC)} style={{marginTop: '24px'}}/>;
const AngularBoomTip = ({system}) => <LabelledInfo title="Angular Boom Tip" subtitle={formatBoolean(system.angularBoomTip)} style={{marginTop: '24px'}}/>;

Version.propTypes =
Aep.propTypes =
Eep.propTypes =
Gxl.propTypes =
Gxxl.propTypes =
HexapodOrientation.propTypes =
Hoist.propTypes =
OneOperator.propTypes =
PinocchioTip.propTypes =
PinPushers.propTypes =
SlewingEncoder.propTypes =
TipHeaveCompensation.propTypes =
BoxPC.propTypes =
AngularBoomTip.propTypes = {
  system: PropTypes.object,
};

const getFields = systemType => {
  switch (systemType) {
    case 'A-type':
      return {
        default: [Version, Aep],
        expand: [Gxl, HexapodOrientation, OneOperator, PinocchioTip, SlewingEncoder, TipHeaveCompensation, AngularBoomTip],
      };
    case 'E-type':
    case 'N-type':
      return {
        default: [Version, Eep],
        expand: [Gxl, Gxxl, HexapodOrientation, Hoist, PinPushers, SlewingEncoder, TipHeaveCompensation, BoxPC],
      };
    case 'L-type':
      return {
        default: [Version, BoxPC],
        expand: [],
      };
    default:
      return {default: [], expand: []};
  }
};

class ExpandableSystemInfo extends React.Component {
  state = {
    isExpanded: false
  }

  toggleExpanded = () => this.setState(prev => ({isExpanded: !prev.isExpanded}));

  renderToggle () {
    return (
      <span style={{display: 'inline-block', fontSize: '14px', marginTop: '20px', cursor: 'pointer'}}>
        <Link onClick={this.toggleExpanded}>
          {`${this.state.isExpanded ? 'Hide' : 'Show'} more information`}
        </Link>
      </span>
    );
  }

  render () {
    const {system} = this.props;
    const {isExpanded} = this.state;
    const fields = getFields(system.type);
    return (
      <>
        {fields.default.map((Field, i) => <Field key={i} system={system}/>)}
        {
          isExpanded
            ? <>
              {fields.expand.map((Field, i) => <Field key={i} system={system}/>)}
              {this.renderToggle()}
            </>
            : fields.expand.length > 0
              ? this.renderToggle()
              : null
        }
      </>
    );
  }
}

ExpandableSystemInfo.propTypes = {
  system: PropTypes.object,
};

export default ExpandableSystemInfo;
